<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="searchForm.user_id" clearable placeholder="推荐人或被邀请人ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="log_id" label="记录ID" width="90"></el-table-column>
          <el-table-column label="被邀请人">
            <template slot-scope="scope">
              <div v-if="scope.row.invitee">
                <img class="radius" v-img-url="scope.row.invitee.avatarUrl" width="24" height="24" />
                <span class="pl8">{{ scope.row.invitee.nickName }} (ID: {{ scope.row.invitee.user_id }})</span>
              </div>
              <span v-else>ID: {{ scope.row.user_id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="推荐人">
            <template slot-scope="scope">
              <div v-if="refereeRow(scope.row)">
                <img class="radius" v-img-url="refereeRow(scope.row).avatarUrl" width="24" height="24" />
                <span class="pl8">{{ refereeRow(scope.row).nickName }} (ID: {{ refereeRow(scope.row).user_id }})</span>
              </div>
              <span v-else>ID: {{ scope.row.referee_user_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bind_time" label="绑定时间" width="160"></el-table-column>
          <el-table-column prop="source" label="来源" width="140">
            <template slot-scope="scope">
              {{ sourceLabel(scope.row.source) }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="记录时间" width="160"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DistributionApi from '@/api/distribution.js'

const SOURCE_MAP = {
  login_inviter_code: '登录邀请码',
  register_inviter_code: '注册邀请码',
  register_bind: '注册/授权绑定',
  admin_agent: '后台分销修改',
  unknown: '未知'
}

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 15,
      totalDataNumber: 0,
      curPage: 1,
      searchForm: {
        user_id: ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    refereeRow(row) {
      return row.refereeUser || row.referee_user || null
    },
    sourceLabel(code) {
      return SOURCE_MAP[code] || code || '-'
    },
    getData() {
      const self = this
      const Params = Object.assign({}, self.searchForm, {
        page: self.curPage,
        list_rows: self.pageSize
      })
      self.loading = true
      DistributionApi.refereeBindLogList({ Params }, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.list.data || []
          self.totalDataNumber = res.data.list.total || 0
        })
        .catch(() => {
          self.loading = false
        })
    },
    onSubmit() {
      this.curPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.curPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>
.radius {
  border-radius: 50%;
}
.pl8 {
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/bindlog/index.vue